import {AxiosPromise} from "axios";
import {addParametersToEndpoint, request} from "../../common/utils/apiHelpers";
import {OfferVersionResponse} from "./models";

export type OfferLanguage = 'ru' | 'kk';

/**
 * Получить текст текущей офферты
 */
export const requestGetOffer = (lang: OfferLanguage): AxiosPromise<OfferVersionResponse> =>
  request(addParametersToEndpoint('/offer/current', {lang}))

/**
 * Принять офферту
 */
export const requestAcceptOffer = (): AxiosPromise<void> =>
  request('/offer/accept', 'POST')
